import * as React from 'react';

import { AiSummaryModalMobile, type IAiSummaryMobileActions } from '../../components/AiSummaryModalMobile';
import { mockNewbuildingContacts } from '../../components/AiSummaryModalDesktop/mockNewbuildingContacts';
import { NewbuildingCallToAction } from '../NewbuildingCallToAction';
import { NewbuildingChatButton } from '../NewbuildingChatButton';

export interface IAiSummaryModalMobileContainerProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export const AiSummaryModalMobileContainer = ({
  open,
  onOpenChange,
}: IAiSummaryModalMobileContainerProps): React.JSX.Element => {
  const handleClose = React.useCallback(() => onOpenChange(false), [onOpenChange]);
  const actions = React.useMemo<IAiSummaryMobileActions[]>(
    () =>
      mockNewbuildingContacts.map(newbuilding => {
        const hasChat = [...newbuilding.builders, ...newbuilding.sellers].some(contact => contact.chat?.enabled);

        return {
          newbuildingId: newbuilding.newbuildingId,
          call: (
            <NewbuildingCallToAction
              onlyIcon
              builders={newbuilding.builders}
              newbuildingId={newbuilding.newbuildingId}
              sellers={newbuilding.sellers}
              url={newbuilding.url}
            />
          ),
          chat: hasChat ? (
            <NewbuildingChatButton
              builders={newbuilding.builders}
              fullscreen
              newbuildingId={newbuilding.newbuildingId}
              sellers={newbuilding.sellers}
              size="XS"
              url={newbuilding.url}
            />
          ) : undefined,
        };
      }),
    [],
  );

  return <AiSummaryModalMobile actions={actions} onClose={handleClose} open={open} />;
};
